import createAxiosInstance from "./Axios";
import { setNewAuthToken } from "./ApiHelperFunctions";
import { Logger } from "../utils/Logger";
import { logout } from "../redux/actions";

export const getAllNotification = async (dispatch?: any, data?: any) => {
  const axiosInstance = await createAxiosInstance();
  try {
    const response = await axiosInstance.get("/api/notifications", {
      params: data,
    });
    if (dispatch) {
      setNewAuthToken(dispatch, response.data.result?.access_token);
    }
    return response.data;
  } catch (err: any) {
    Logger.error("Search Results: ", err);
    if (err?.response?.status === 401 && dispatch) {
      dispatch(logout());
    }
    throw err;
  }
};

export const getUnreadCount = async (dispatch?: any) => {
  const axiosInstance = await createAxiosInstance();
  try {
    const response = await axiosInstance.get("/api/notifications/unread-count");
    if (dispatch) {
      setNewAuthToken(dispatch, response.data.result?.access_token);
    }
    return response.data;
  } catch (err: any) {
    Logger.error("Search Results: ", err);
    if (err?.response?.status === 401 && dispatch) {
      dispatch(logout());
    }
    throw err;
  }
};

export const markedAllAsRead = async (dispatch?: any) => {
  const axiosInstance = await createAxiosInstance();
  try {
    const response = await axiosInstance.put(
      `/api/notifications/mark-all-read`
    );
    setNewAuthToken(dispatch, response.data.result?.access_token);
    return response.data;
  } catch (err: any) {
    if (err?.response?.status === 401) {
      dispatch(logout());
    }
    throw err;
  }
};

export const markedAsRead = async (dispatch?: any, id?: number) => {
  const axiosInstance = await createAxiosInstance();
  try {
    const response = await axiosInstance.put(
      `/api/notifications/${id}/mark-read`
    );
    setNewAuthToken(dispatch, response.data.result?.access_token);
    return response.data;
  } catch (err: any) {
    if (err?.response?.status === 401) {
      dispatch(logout());
    }
    throw err;
  }
};
